import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthLayout() {
  const { currentUser } = useAuth ? useAuth() : { currentUser: null };
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img
          className="mx-auto h-12 w-auto"
          src="/orrekie-logo.png"
          alt="Orrekie"
        />
        {currentUser?.email && (
          <span style={{ color: '#333', fontWeight: 500, fontSize: '1rem', marginLeft: '1.5rem' }} title="Your email">{currentUser.email}</span>
        )}
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
} 